import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// v69 — a hidden creator met in onboarding / Add anyway (admins only): a calm note.
export function HiddenNote({ id, name, testid = "hidden-note" }) {
  const [ask, setAsk] = useState(false);
  const [done, setDone] = useState(false);
  const unhide = async () => {
    try {
      await api.delete(`/admin/hidden-creators/${encodeURIComponent(id)}`);
      setDone(true);
      toast.success(`${name} is visible again`);
    } catch { toast.error("Could not unhide. Try the Hidden Creators page."); }
  };
  return (
    <div className="text-sm rounded-md border hairline px-3 py-2.5" style={{ background: "var(--surface-2)" }} data-testid={testid}>
      <div className="text-white" data-testid={`${testid}-text`}>{name} is already on KOL Radar.</div>
      <div className="mt-2 flex items-center gap-2 flex-wrap">
        {done ? <span className="text-xs text-zinc-400" data-testid={`${testid}-unhidden`}>Unhidden.</span> : (
          <button type="button" onClick={() => setAsk(true)} data-testid={`${testid}-unhide`}
            className="text-xs px-2.5 py-1 rounded-md border hairline text-white hover:border-white/30 transition-colors duration-150">Unhide</button>
        )}
        <Link to={`/admin/hidden-creators?q=${encodeURIComponent(id)}`} data-testid={`${testid}-view`}
          className="text-xs px-2.5 py-1 rounded-md border hairline text-zinc-300 hover:text-white hover:border-white/30 transition-colors duration-150">View in Hidden Creators</Link>
      </div>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent data-testid={`${testid}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Unhide {name}?</AlertDialogTitle>
            <AlertDialogDescription>He becomes visible again everywhere on KOL Radar.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid={`${testid}-confirm`} onClick={unhide} className="bg-white text-black hover:bg-zinc-200">Unhide</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
